import { useState } from "react";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { Share2, Save, Loader2 } from "lucide-react";
import { toast } from "sonner";
import api, { formatApiError } from "@/lib/api";
import { money } from "@/lib/format";

const Row = ({ s }) => {
  const qc = useQueryClient();
  const [val, setVal] = useState(s.price ?? "");
  const [saving, setSaving] = useState(false);
  const save = async () => {
    setSaving(true);
    try {
      await api.put(`/manager/services/${s.id}/my-center-price`, { price: val === "" ? null : Number(val) });
      toast.success("Price saved for your center");
      qc.invalidateQueries({ queryKey: ["mgr-shared-services"] });
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
    finally { setSaving(false); }
  };
  return (
    <div className="eyw-card p-4 flex items-center gap-3 flex-wrap" data-testid={`mgr-shared-${s.id}`}>
      <div className="flex-1 min-w-0">
        <p className="text-sm font-semibold text-[#1A242B]">{s.title}</p>
        <p className="text-xs text-[#8FA89B]">{s.duration_min}m · usual price {money(Number(s.base_price || 0))}</p>
      </div>
      <input type="number" min="0" step="1" value={val} placeholder="Usual" onChange={(e) => setVal(e.target.value)}
        data-testid={`mgr-shared-price-${s.id}`} className="eyw-input !py-1.5 w-28 text-sm" />
      <button onClick={save} disabled={saving} data-testid={`mgr-shared-save-${s.id}`} className="eyw-btn-ghost !py-1.5 !px-3 text-xs">
        {saving ? <Loader2 className="animate-spin" size={13} /> : <Save size={13} />} Save
      </button>
    </div>
  );
};

// Services owned by another center but offered here: this center sets only its own price.
export const SharedServicesPrices = () => {
  const { data = [] } = useQuery({ queryKey: ["mgr-shared-services"], queryFn: () => api.get("/manager/me/shared-services").then((r) => r.data) });
  if (!data.length) return null;
  return (
    <div className="mt-8" data-testid="mgr-shared-services">
      <h3 className="font-serif text-xl text-[#1A242B] mb-1 flex items-center gap-2"><Share2 size={17} /> Shared services offered at your center</h3>
      <p className="text-xs text-[#4A5D6B] mb-3">Another center runs these. You can set the price members pay at your center — leave blank to use the usual price.</p>
      <div className="space-y-2">{data.map((s) => <Row key={s.id} s={s} />)}</div>
    </div>
  );
};
